/**
 * puzzle-cart-monitor.js
 * Script global — s'exécute sur toutes les pages.
 *
 * Deux comportements :
 *   1. Si le client retire manuellement le produit puzzle du panier
 *      → appel backend { type: 'unlock', variantId } pour effacer le metafield.
 *
 *   2. Si le timer de 5 min expire et que le produit est encore dans le panier
 *      → retrait automatique via /cart/change.js + appel backend unlock.
 *
 * Le bridge avec puzzle-product.js se fait via localStorage :
 *   clé  : 'puzzle_lock'
 *   valeur: { variantId, lockedAt (ms), apiEndpoint }
 */
(function () {
  var LOCK_DURATION_MS = 5 * 60 * 1000; // 5 minutes
  var STORAGE_KEY      = 'puzzle_lock';
  var expiryTimer      = null;

  // ── Helpers localStorage ────────────────────────────────────────────────

  function getLockData() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function clearLockData() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // ── Appel backend ───────────────────────────────────────────────────────

  function unlockVariant(apiEndpoint, variantId) {
    if (!apiEndpoint) {
      console.warn('[PuzzleMonitor] unlock — api_endpoint manquant, skip');
      return Promise.resolve();
    }
    console.log('[PuzzleMonitor] unlock → POST', apiEndpoint, '— variantId:', variantId);
    return fetch(apiEndpoint, {
      method:  'POST',
      headers: { 'Content-Type': 'text/plain' },
      body:    JSON.stringify({ type: 'unlock', variantId: variantId })
    })
      .then(function (r) {
        if (!r.ok && r.status !== 409) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        console.log('[PuzzleMonitor] unlock ← réponse backend :', data);
      })
      .catch(function (err) {
        console.warn('[PuzzleMonitor] unlock — erreur backend :', err.message);
      });
  }

  // ── Suppression du panier ───────────────────────────────────────────────

  function removeFromCart(variantId) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === variantId) { item = cart.items[i]; break; }
        }
        if (!item) return null; // déjà absent

        return fetch('/cart/change.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: item.key, quantity: 0 })
        }).then(function (r) { return r.json(); });
      });
  }

  // ── Expiration : retrait automatique ────────────────────────────────────

  function handleExpiry(lockData) {
    console.log('[PuzzleMonitor] Lock expiré — retrait du variant', lockData.variantId);
    clearExpiryTimer();
    clearLockData();

    removeFromCart(lockData.variantId)
      .then(function (result) {
        if (result === null) {
          console.log('[PuzzleMonitor] Variant déjà absent du panier à l\'expiry');
        } else {
          console.log('[PuzzleMonitor] Variant retiré du panier automatiquement');
          // Rafraîchir la page panier si on y est
          if (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart') === 0) {
            showExpiryBanner();
            setTimeout(function () { window.location.reload(); }, 3000);
          }
          // Mettre à jour le tiroir panier s'il existe (Dawn theme)
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function (err) {
        console.warn('[PuzzleMonitor] Erreur suppression panier :', err.message);
      })
      .then(function () {
        // Toujours appeler unlock, même si la suppression a échoué
        unlockVariant(lockData.apiEndpoint, lockData.variantId);
      });
  }

  function showExpiryBanner() {
    var banner = document.getElementById('puzzle-expiry-banner');
    if (banner) return;
    banner = document.createElement('div');
    banner.id = 'puzzle-expiry-banner';
    banner.style.cssText = [
      'position:fixed', 'top:0', 'left:0', 'right:0', 'z-index:9999',
      'background:#dc3545', 'color:#fff', 'text-align:center',
      'padding:12px 16px', 'font-size:14px', 'font-weight:500'
    ].join(';');
    banner.textContent = 'Votre réservation a expiré (5 min). La pièce a été retirée de votre panier.';
    document.body.insertAdjacentElement('afterbegin', banner);
  }

  // ── Bannière countdown sur la page panier ───────────────────────────────

  function showCartCountdown(deadline) {
    var onCartPage = window.location.pathname === '/cart' ||
                     window.location.pathname.indexOf('/cart') === 0;
    if (!onCartPage) return;

    // Attendre que le DOM soit prêt avant d'insérer
    function inject() {
      if (document.getElementById('puzzle-cart-countdown')) return;

      var banner = document.createElement('div');
      banner.id = 'puzzle-cart-countdown';
      banner.style.cssText = [
        'background:#fff3cd', 'border:1px solid #ffc107', 'border-radius:4px',
        'padding:10px 16px', 'margin:0 0 12px', 'font-size:14px', 'line-height:1.4'
      ].join(';');

      function tick() {
        var remaining = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        if (remaining === 0) { banner.remove(); return; }
        var m       = Math.floor(remaining / 60);
        var s       = remaining % 60;
        var timeStr = m > 0
          ? (m + ' min ' + (s < 10 ? '0' : '') + s + ' s')
          : (s + ' s');
        banner.innerHTML =
          '⏳ <strong>Pièce réservée temporairement</strong> — ' +
          'Cette pièce sera automatiquement retirée dans <strong>' + timeStr + '</strong>. ' +
          'Finalisez votre commande avant expiration.';
      }

      tick();
      var timerRef = setInterval(tick, 1000);
      banner._clearTimer = function () { clearInterval(timerRef); };

      // Insérer en tête de la zone panier principale
      var target = document.querySelector('[id^="main-cart"]') ||
                   document.querySelector('.cart__items') ||
                   document.querySelector('main');
      if (target) target.insertAdjacentElement('afterbegin', banner);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inject);
    } else {
      inject();
    }
  }

  // ── Timer d'expiration ──────────────────────────────────────────────────

  function scheduleExpiry(lockData, remaining) {
    clearExpiryTimer();
    expiryTimer = setTimeout(function () { handleExpiry(lockData); }, remaining);
    console.log('[PuzzleMonitor] Expiry programmée dans', Math.round(remaining / 1000), 's');
  }

  function clearExpiryTimer() {
    if (expiryTimer) { clearTimeout(expiryTimer); expiryTimer = null; }
  }

  // ── Écoute des retraits manuels ─────────────────────────────────────────
  //
  //  Dawn utilise un custom element <cart-remove-button> qui déclenche une
  //  requête AJAX, puis met à jour le DOM du panier/tiroir.
  //  On intercepte le clic sur le bouton (data-variant-id) pour vérifier
  //  après la requête si le variant puzzle n'est plus dans le panier.

  function listenCartRemovals(lockData) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-variant-id]');
      if (!btn) return;

      var clickedVariantId = parseInt(btn.dataset.variantId, 10);
      if (clickedVariantId !== lockData.variantId) return;

      console.log('[PuzzleMonitor] Clic retrait détecté pour variant puzzle', lockData.variantId);

      // On attend que Dawn ait fini sa requête AJAX (~800 ms), puis on vérifie
      setTimeout(function () {
        var current = getLockData();
        if (!current || current.variantId !== lockData.variantId) return; // déjà géré

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var stillInCart = cart.items.some(function (i) {
              return i.variant_id === lockData.variantId;
            });
            if (!stillInCart) {
              console.log('[PuzzleMonitor] Variant retiré manuellement — unlock backend');
              clearExpiryTimer();
              clearLockData();

              var countdown = document.getElementById('puzzle-cart-countdown');
              if (countdown) {
                if (countdown._clearTimer) countdown._clearTimer();
                countdown.remove();
              }

              unlockVariant(lockData.apiEndpoint, lockData.variantId);
            }
          })
          .catch(function (err) {
            console.warn('[PuzzleMonitor] Vérification post-retrait — erreur :', err.message);
          });
      }, 900);
    });
  }

  // ── Vérification initiale au chargement de page ─────────────────────────

  function checkCartOnLoad(lockData) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = cart.items.some(function (i) {
          return i.variant_id === lockData.variantId;
        });

        if (!inCart) {
          // Le client a retiré le produit entre deux pages ou depuis un autre onglet
          console.log('[PuzzleMonitor] Variant absent du panier au chargement — unlock');
          clearLockData();
          unlockVariant(lockData.apiEndpoint, lockData.variantId);
          return;
        }

        var elapsed   = Date.now() - lockData.lockedAt;
        var remaining = LOCK_DURATION_MS - elapsed;

        if (remaining <= 0) {
          handleExpiry(lockData);
          return;
        }

        var deadline = Date.now() + remaining;
        scheduleExpiry(lockData, remaining);
        showCartCountdown(deadline);
        listenCartRemovals(lockData);
      })
      .catch(function (err) {
        console.warn('[PuzzleMonitor] Vérification panier au chargement — erreur :', err.message);
        // En cas d'erreur réseau, on programme quand même l'expiry
        var elapsed   = Date.now() - lockData.lockedAt;
        var remaining = LOCK_DURATION_MS - elapsed;
        if (remaining > 0) {
          scheduleExpiry(lockData, remaining);
          listenCartRemovals(lockData);
        }
      });
  }

  // ── Point d'entrée ──────────────────────────────────────────────────────

  function init() {
    var lockData = getLockData();
    if (!lockData || !lockData.variantId || !lockData.lockedAt) return;

    console.log('[PuzzleMonitor] Init — variantId:', lockData.variantId,
      '— verrouillé à', new Date(lockData.lockedAt).toLocaleTimeString());

    checkCartOnLoad(lockData);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
